import axios from 'axios';
import FileDownload from 'js-file-download';
import { dashboardBuild } from '../../Audit/dashboardBuild';

import {
    DASHBOARD_DATA_REQUEST,
    DASHBOARD_DATA_SUCCESS,
    DASHBOARD_SINGLE_DATA_REQUEST,
    DASHBOARD_SINGLE_DATA_SUCCESS,
    DASHBOARD_DATA_FAILURE,
    DASHBOARD_SET_FILTER,
    DASHBOARD_RESET,
    DASHBOARD_FILTER_REQUEST,
    DASHBOARD_FILTER_SUCCESS,
    DASHBOARD_FILTER_FAILURE,
    DASHBOARD_ADD_FILTER,
    DASHBOARD_CONFIG_SUCCESS,
    DASHBOARD_EXPORT_REQUEST,
    DASHBOARD_EXPORT_SUCCESS,
    DASHBOARD_EXPORT_FAILURE,
    CASEVIEW_DATA_SUCCESS,
    FILE_COUNT_SUCCESS,
    METRICS_DATA_SUCCESS,
    DASHBOARD_SAVE_QUICK_TEXT,
} from './DashboardReducer';
import { requestFileDownload, successFileDownload } from '../Case/CaseReducer';
import { sec } from '../../../security';
import config from '../../../auth.config';

const API_ROOT = process.env.REACT_APP_API_ROOT;
const API_EXPORT_DASHBOARD = process.env.REACT_APP_API_DASHBOARD_EXPORT;

//= ========Thunks===========

export const getDashboardData =
    (
        queryType,
        dataType,
        fields,
        code,
        addCount,
        groupBy,
        limit,
        sortAsc,
        sortField,
        where,
        startFrom,
        freeTextSearch
    ) =>
    async (dispatch) => {
        const access_token = await sec.getAccessTokenSilently()({
            audience: config.audience,
        });
        dispatch({ type: DASHBOARD_SINGLE_DATA_REQUEST, dataType });
        return await axios({
            method: 'POST',
            url: `${API_ROOT}/${queryType.toUpperCase()}/dashboard/${code}/query`,
            data: {
                addCount,
                groupBy,
                fields,
                limit,
                sortAsc,
                sortField,
                where,
                from: startFrom,
                text: freeTextSearch,
            },
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                Accept: 'application/json',
                Authorization: `Bearer ${access_token}`,
            },
        })
            .then((response) => {
                const data = response.data;
                if (dataType === 'tableData' && data.items.length > 0) {
                    const initialFields = {
                        causeOfDeath: null,
                        contributingFactors: null,
                        deputyCoroner: null,
                        mannerOfDeath: null,
                        meansOfDeath: null,
                        pathologist: null,
                        policeAgency: null,
                        race: null,
                        sexFormatted: null,
                        deathZip: null,
                        deathDate: null,
                    };
                    const merged = {
                        ...initialFields,
                        ...response.data.items[0],
                    };
                    data.items.splice(0, 1, merged);
                }
                dispatch({
                    type: DASHBOARD_SINGLE_DATA_SUCCESS,
                    payload: data,
                    dataType,
                    code,
                });
                return data;
            })
            .catch((error) => {
                dispatch({ type: DASHBOARD_DATA_FAILURE, error });
            });
    };

export const getDashboardDataMultiple =
    (queryType, code, queries, metrics?) => async (dispatch) => {
        const access_token = await sec.getAccessTokenSilently()({
            audience: config.audience,
        });

        dispatch({ type: DASHBOARD_DATA_REQUEST });

        return await axios({
            method: 'POST',
            url: `${API_ROOT}/${queryType.toUpperCase()}/dashboard/${code}/query/multiple`,
            data: queries,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                Accept: 'application/json',
                Authorization: `Bearer ${access_token}`,
            },
        })
            .then((response) => {
                let loading = false;
                // if (queries.topCausesOfDeath) {
                //   loading = true;
                // }

                if (metrics) {
                    dispatch({
                        type: METRICS_DATA_SUCCESS,
                        payload: response.data,
                        code,
                        loading,
                    });
                } else if (queryType === 'CASE') {
                    dispatch({
                        type: CASEVIEW_DATA_SUCCESS,
                        payload: response.data,
                        code,
                        loading,
                    });
                } else if (queryType === 'FILE') {
                    dispatch({
                        type: FILE_COUNT_SUCCESS,
                        payload: response.data,
                        code,
                        loading,
                    });
                } else {
                    dispatch({
                        type: DASHBOARD_DATA_SUCCESS,
                        payload: response.data,
                        code,
                        loading,
                    });
                }
                return response.data;
            })
            .catch((error) => {
                dispatch({ type: DASHBOARD_DATA_FAILURE, error });
            });
    };

export const exportDashboardData =
    (queryType, code, dataType, query) => async (dispatch) => {
        const access_token = await sec.getAccessTokenSilently()({
            audience: config.audience,
        });
        dispatch(requestFileDownload(dataType));

        return await axios({
            method: 'POST',
            url: `${API_ROOT}/${queryType}/dashboard/${code}/export`,
            data: query,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                Accept: 'text/plain',
                Authorization: `Bearer ${access_token}`,
            },
            responseType: 'blob',
        })
            .then((response) => {
                dispatch(
                    successFileDownload(
                        dataType,
                        dataType + '.csv',
                        response.data
                    )
                );
                return response.data;
            })
            .catch((error) => {
                dispatch({ type: DASHBOARD_DATA_FAILURE, error });
            });
    };

export const getFilterValues = (queryType, code, id, filterId, typeahead) => {
    const thunk = async (dispatch, getState) => {
        dispatch({
            type: DASHBOARD_FILTER_REQUEST,
            filterId: typeahead ? filterId : id,
        });

        const access_token = await sec.getAccessTokenSilently()({
            audience: config.audience,
        });
        let data;
        if (typeahead) {
            data = {
                groupBy: [filterId],
                limit: 10,
                sortAsc: true,
                sortField: filterId,
                where: {
                    [filterId]: {
                        type: 'STRING',
                        like: id,
                    },
                },
            };
        } else {
            data = {
                groupBy: [id],
                limit: 0,
            };
        }

        axios({
            method: 'POST',
            url: `${API_ROOT}/${queryType}/dashboard/${code}/query`,
            data: data,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                Accept: 'application/json',
                Authorization: `Bearer ${access_token}`,
            },
        })
            .then((response) => {
                dispatch({
                    type: DASHBOARD_FILTER_SUCCESS,
                    payload: response.data,
                    filterId: typeahead ? filterId : id,
                });
                return response.data;
            })
            .catch((error) => {
                dispatch({ type: DASHBOARD_FILTER_FAILURE, error });
            });
    };

    thunk.meta = {
        debounce: {
            time: 500,
            key: 'filter-values-lookup',
        },
    };
    return thunk;
};

export const setFilters = (filters) => (dispatch) => {
    dispatch({ type: DASHBOARD_SET_FILTER, payload: filters });
};

export const addFilter = (filters) => (dispatch) => {
    dispatch({ type: DASHBOARD_ADD_FILTER, payload: filters });
};

export const reset = () => (dispatch) => {
    dispatch({ type: DASHBOARD_RESET });
};

export const getDashboardConfig =
    (type, code, config?, setFilters?) => (dispatch) => {
        if (type === 'activity') {
            dispatch({
                type: DASHBOARD_CONFIG_SUCCESS,
                payload: dashboardBuild(type, null, null, setFilters),
                id: code,
            });
        } else {
            dispatch({
                type: DASHBOARD_CONFIG_SUCCESS,
                payload: dashboardBuild(type, code, config),
                id: code,
            });
        }
    };

export const exportDashboard =
    (type, code, build, filters, text) => async (dispatch) => {
        dispatch({
            type: DASHBOARD_EXPORT_REQUEST,
        });

        const access_token = await sec.getAccessTokenSilently()({
            audience: config.audience,
        });

        axios({
            method: 'POST',
            url: API_EXPORT_DASHBOARD,
            data: {
                token: access_token,
                filters,
                text,
                build: JSON.stringify(build, (_key, val) => {
                    if (typeof val === 'function') {
                        return val + ''; // implicitly `toString` it
                    }
                    return val;
                }),
                urlQuery: `${API_ROOT}/${type}/dashboard/${code}/query/multiple`,
            },
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                Accept: 'application/json',
            },
            responseType: 'blob',
        })
            .then((response) => {
                FileDownload(response.data, `report_${type}_${code}.pdf`);
                dispatch({
                    type: DASHBOARD_EXPORT_SUCCESS,
                });
                return response.data;
            })
            .catch((error) => {
                dispatch({ type: DASHBOARD_EXPORT_FAILURE, error });
            });
    };

export const quickTextSearch = (text: string) => async (dispatch) => {
    dispatch({
        type: DASHBOARD_SAVE_QUICK_TEXT,
        payload: text,
    });
};
